import { useTranslation } from "@refinedev/core";
import { FaGoogle, FaTriangleExclamation, FaXmark } from "react-icons/fa6";

interface PopupBlockedModalProps {
    isOpen: boolean;
    onClose: () => void;
    onTryAgain: () => void;
}

export const PopupBlockedModal = ({ isOpen, onClose, onTryAgain }: PopupBlockedModalProps) => {
    const { translate } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                onClick={onClose}
                className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300"
            />

            {/* Modal Content */}
            <div
                className="relative w-full max-w-md bg-base-100 rounded-3xl shadow-2xl overflow-hidden transition-all duration-300 transform scale-100 opacity-100"
            >
                <div className="p-8 flex flex-col items-center text-center">
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 p-2 hover:bg-base-200 rounded-full transition-colors"
                    >
                        <FaXmark className="w-5 h-5 text-base-content/50" />
                    </button>

                    {/* Warning Icon Overlay */}
                    <div className="mb-6 relative">
                        <div className="w-20 h-20 bg-warning/10 rounded-full flex items-center justify-center">
                            <FaTriangleExclamation className="w-10 h-10 text-warning" />
                        </div>
                        <div
                            className="absolute -top-1 -right-1 w-6 h-6 bg-error rounded-full border-4 border-base-100 animate-pulse"
                        />
                    </div>

                    <h3 className="text-2xl font-bold text-secondary mb-3">
                        {translate("common.auth.errors.popup-blocked-modal.title")}
                    </h3>

                    <p className="text-base-content/70 mb-8 leading-relaxed">
                        {translate("common.auth.errors.popup-blocked-modal.description")}
                    </p>

                    <button
                        onClick={() => {
                            onTryAgain();
                            onClose();
                        }}
                        className="btn btn-secondary btn-lg w-full group transition-all duration-300 gap-3"
                    >
                        <FaGoogle className="w-5 h-5 group-hover:scale-110 transition-transform" />
                        {translate("common.auth.errors.popup-blocked-modal.try-again")}
                    </button>

                    <button
                        onClick={onClose}
                        className="btn btn-ghost mt-4 text-base-content/40 hover:text-base-content/70"
                    >
                        {translate("app.close")}
                    </button>
                </div>

                {/* Decorative bottom bar */}
                <div className="h-2 w-full bg-gradient-to-r from-primary via-secondary to-accent opacity-50" />
            </div>
        </div>
    );
};
